<script setup lang="ts">
import { StoryblokComponent } from '@storyblok/vue'

interface Props {
  blok: {
    title: string
    links: any[]
  }
}
defineProps<Props>()

const theme = useTheme()
</script>

<template>
  <div v-editable="blok" class="gap-2 md:gap-3 hidden md:flex flex-col px-3">
    <p
      class="font-inter font-medium text-base" :style="{
        color: theme.colors.softBlack,
        fontVariantNumeric: 'lining-nums proportional-nums',
        fontFeatureSettings: 'cv09 on, cv01 on',
      }"
    >
      {{ blok.title }}
    </p>
    <StoryblokComponent v-for="link in blok.links" :key="link._uid" :class="$style.footerLink" :blok="link" />
  </div>
  <div
    v-editable="blok" class="gap-2 md:gap-3 block md:hidden footerListMobile"
    :style="{
      '--expansion-panel-arrow-color': theme.colors.spGray3,
    }"
  >
    <ExpansionPanel :color="theme.colors.softBlack" :color-hover="theme.colors.softBlack">
      <slot name="title">
        <p
          class="font-inter font-medium text-base" :style="{
            color: theme.colors.softBlack,
          }"
        >
          {{ blok.title }}
        </p>
      </slot>
      <template #expansion-panel-content>
        <div class="pl-5 pt-3">
          <div class="flex flex-col gap-3">
            <StoryblokComponent v-for="link in blok.links" :key="link._uid" :class="$style.footerLink" :blok="link" />
          </div>
        </div>
      </template>
    </ExpansionPanel>
  </div>
</template>

<style lang="scss" module>
  .footerLink {
    p {
      font-size: 14px !important;
    }
  }
</style>

<style lang="scss" scoped>
  .footerListMobile {
    :deep(.label) {
      min-height: 36px !important;
    }

    :deep(.expansion-panel-arrow) {
      svg {
        min-height: 10px;
        width: 30px;
      }
    }

    :deep(svg:not(.arrow-active)) {
      path {
        stroke: var(--expansion-panel-arrow-color) !important;
      }
    }
  }
</style>
